import React from 'react'
import { createRoot } from 'react-dom/client'
import App from 'app/App'
import Site from 'site/Site'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient();

const Root = ({ Inner }) => {
  return <QueryClientProvider client={queryClient}>
           <Inner />
         </QueryClientProvider>
}

// Detect if we're in Cordova or app subdomain
window.isCordova = window.cordova !== undefined
const isAppSubdomain = window.location.hostname.split('.')[0] === 'app'

// Load the appropriate component
const Inner = (isCordova || isAppSubdomain) ? App : Site
window.mountReact = () => {
  const root = createRoot(document.getElementById('app-wrapper'))
  root.render(<Root Inner={ Inner } />);
}

const createNotificationChannel = () => {
  cordova.plugins.notification.local.createChannel({
    id: 'dodo_channel',
    name: 'Dodo Timer',
    androidChannelImportance: 4,
  }, () => {
    console.log('Channel created');
  });
}

if(isCordova) {
  document.addEventListener('deviceready', mountReact);
  document.addEventListener('deviceready', createNotificationChannel);
} else {
  document.addEventListener('DOMContentLoaded', mountReact);
}
